import { render, staticRenderFns } from "./countdown.vue?vue&type=template&id=0c34d8e4&scoped=true"
import script from "./countdown.vue?vue&type=script&lang=js"
export * from "./countdown.vue?vue&type=script&lang=js"
import style0 from "./countdown.vue?vue&type=style&index=0&id=0c34d8e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c34d8e4",
  null
  
)

export default component.exports